import { Base_Url, XeroBaseUrl } from "../../../Base-Url/Base_Url";
import { SelectServiceData } from "../../../Database/ProposalToolDatabase";
import {
  getList,
  getListWithAuthenticated,
  postApi,
  postApiWithAuthenticated,
} from "../../reducer/reduxService";

//Service Category Base Url
const ProposalBaseUrl = `${Base_Url}/configure/Proposal`;
const ProposalBaseUrlQuote = `${Base_Url}/Quote`;
const GetContractDetails = `${Base_Url}/Contract`;

// Arrow function as a method
//Get Service Category List Data Services Callback function
// export const GetProposalList = async (params) => {
//     let url = params.StatusID !== undefined && params.StatusID !== null ?
//         `/GetQuoteList?StatusID=${params.StatusID}` :
//         `/GetQuoteList`
//     const res = await postApiWithAuthenticated(
//         ProposalBaseUrlQuote + url,
//         params
//     );
//     return res;
// };
export const GetProposalList = async (params) => {
  let url =
    params.StatusID !== undefined && params.StatusID !== null
      ? `/GetQuoteList?StatusID=${params.StatusID}&QuotesFor=${params.quoteFor}`
      : `/GetQuoteList?QuotesFor=${params.quoteFor}`;
  const res = await postApiWithAuthenticated(
    ProposalBaseUrlQuote + url,
    params,
  );
  return res;
};
export const GetOldProposalList = async (params) => {
  let url =
    params.StatusID !== undefined && params.StatusID !== null
      ? `/GetOldQuoteList?StatusID=${params.StatusID}`
      : `/GetOldQuoteList`;
  const res = await postApiWithAuthenticated(
    ProposalBaseUrlQuote + url,
    params,
  );
  return res;
};

//Get Service Category Model Data Services Callback function
export const GetProposalModel = async (id) => {
  const res = await getListWithAuthenticated(
    `${ProposalBaseUrlQuote}/GetQuoteModel?QuoteKeyID=${id}`,
  );
  return res;
};

export const GetProposalModelWithoutToken = async (id) => {
  const res = await getList(
    `${ProposalBaseUrlQuote}/GetQuoteModel?QuoteKeyID=${id}`,
  );
  return res;
};

// Background color, font family and organisation description used to theme
// the web proposal's stepper screens. Runs outside the authenticated app, so
// no token (mirrors GetProposalModelWithoutToken).
export const GetOrganisationThemeSettings = async (ids) => {
  const res = await getList(
    `${ProposalBaseUrlQuote}/GetOrganisationThemeSettings?QuoteKeyID=${ids.quoteKeyID}${
      ids?.contractSignatoryKeyID != null
        ? `&ContractSignatoryKeyID=${ids.contractSignatoryKeyID}`
        : ""
    }`,
  );
  return res;
};

// Records that the contract signatory acknowledged their payment authority
// before the proposal flow continues. No auth token (mirrors AmendWebProposal).
export const ConfirmProposalAuthority = async (params) => {
  const res = await postApi(
    `${ProposalBaseUrlQuote}/ConfirmProposalAuthority`,
    params,
  );
  return res;
};

// Lookup list of all global pricing driver variables available for the web
// proposal's Input Fields step. Runs outside the authenticated app, so no
// token (mirrors GetProposalModelWithoutToken).
export const GetGlobalProspectVariablesByPricingSettingsForWebProposal = async (
  id,
) => {
  const res = await getList(
    `${ProposalBaseUrlQuote}/GetGlobalProspectVariablesByPricingSettingsForWebProposal?QuoteKeyID=${id}`,
  );
  return res;
};

// Same endpoint AddUpdateProposal.jsx calls (GetTemplateModelData in
// TemplateApi.jsx, TemplateTypeID: 1) for its ModelData.templateElementListWithRequiredData
// (organisationLogoUrl/clientNameOnFirstPage — used to build the PDF's
// first/cover page, AddUpdateProposal.jsx:21537-21565) — verified directly
// against the live API that it doesn't require an auth token, so it's
// callable from the unauthenticated web proposal route the same way
// GetProposalModelWithoutToken is.
export const GetTemplateModelDataWithoutToken = async ({
  templateKeyID,
  clientID,
  moduleKeyID,
}) => {
  const url =
    `${Base_Url}/Template/GetMasterTemplateDetailsWithVariableValues` +
    `?TemplateKeyID=${templateKeyID}&clientID=${clientID}&TemplateTypeID=1` +
    (moduleKeyID ? `&ModuleKeyID=${moduleKeyID}` : "");
  const res = await getList(url);
  return res;
};

// Same endpoint AddUpdateProposal.jsx calls (GetTemplateListLookupList in
// TemplateApi.jsx, via GetProposalEngLetterTemplateLookUpList) for each
// template's headerContent/footerContent/headerImage/footerImage/
// headerHeight/footerHeight/watermarkImage/showSeparatorLines
// (AddUpdateProposal.jsx:20830-20894, saved into state at :21036-21043) —
// verified directly against the live API with no token that it returns 200
// (TemplateApi.jsx's own GetTemplateListLookupList uses
// getListWithAuthenticated, but the backend doesn't actually require a
// token for it — same situation as GetMasterTemplateDetailsWithVariableValues
// above).
export const GetTemplateHeaderFooterLookupWithoutToken = async ({
  organisationKeyID,
  clientID,
  quoteKeyID,
}) => {
  const url =
    clientID != null
      ? `${Base_Url}/Template/GetProposalEnggLetterTemplateLookUpList?OrganisationKeyID=${organisationKeyID}&TemplateTypeID=1&clientID=${clientID}`
      : `${Base_Url}/Template/GetProposalEnggLetterTemplateLookUpList?OrganisationKeyID=${organisationKeyID}&TemplateTypeID=1&QuoteKeyID=${quoteKeyID}`;
  const res = await getList(url);
  return res;
};

// Same endpoint AddUpdateProposal.jsx calls (GetOrganisationInformationModel,
// AddUpdateProposal.jsx:20754-20804) for the organisation's email/phone/
// address/website — used to build the PDF's per-page header/footer contact
// line (email/mobile/fullAddress/webSite in sendDataToBackend's postData).
// Previously required an auth token (confirmed via a live 401); that
// requirement has since been removed, so this is now callable the same way
// GetProposalModelWithoutToken is.
export const GetOrganisationInformationModelWithoutToken = async (
  organisationKeyID,
) => {
  const res = await getList(
    `${Base_Url}/Organisation/GetOrganisationInformationModel/?OrganisationKeyID=${organisationKeyID}`,
  );
  return res;
};
//AddUpdate Service Category Callback function
export const AddUpdateProposal = async (url, params) => {
  const res = await postApiWithAuthenticated(
    `${ProposalBaseUrl}${url}`,
    params,
  );
  return res;
};

//Delete Service Category Callback function
export const DeleteProposal = async (id) => {
  const res = await getListWithAuthenticated(
    `${ProposalBaseUrl}/ProposalDelete?keyID=${id}`,
  );
  return res;
};

//Delete Service Category Callback function
export const ProposalChangeStatus = async (id) => {
  const res = await getListWithAuthenticated(
    `${ProposalBaseUrl}/ProposalChangeStatus?keyID=${id}`,
  );
  return res;
};

export const AddUpdateQuote = async (url, params) => {
  const res = await postApiWithAuthenticated(
    `${ProposalBaseUrlQuote}${url}`,
    params,
  );
  return res;
};

// AcceptAndDeclinemodeApi

export const GetSelectedServicePackageAccept = async (
  quoteKeyID,
  servicePackageKeyID,
  Action,
  ServiceChargeTypeID,
  ContractSignatoryKeyID,
) => {
  let url;

  if (servicePackageKeyID !== null) {
    if (ContractSignatoryKeyID === undefined) {
      url = `/GetAcceptedQuotationServiceDetails?QuoteKeyID=${quoteKeyID}&Action=${Action}&ServiceChargeTypeID=${ServiceChargeTypeID}&ServicePackageKeyID=${servicePackageKeyID}`;
    } else {
      url = `/GetAcceptedQuotationServiceDetails?QuoteKeyID=${quoteKeyID}&Action=${Action}&ServiceChargeTypeID=${ServiceChargeTypeID}&ServicePackageKeyID=${servicePackageKeyID}&ContractSignatoryKeyID=${ContractSignatoryKeyID}`;
    }
  } else {
    // Handle the case when servicePackageKeyID is null
    url = `/GetAcceptedQuotationServiceDetails?QuoteKeyID=${quoteKeyID}&Action=${Action}&ServiceChargeTypeID=${ServiceChargeTypeID}`;
  }

  const res =
    // SelectServiceData
    await getListWithAuthenticated(ProposalBaseUrlQuote + url);
  return res;
};

export const GetQuoteContractViewPDFurl = async (
  UserKeyID,
  OrganisationKeyID,
  ModuleName,
  ModuleKeyID,
) => {
  const res =
    // SelectServiceData
    await getListWithAuthenticated(
      `${ProposalBaseUrlQuote}/GetQuoteCotractViewPDFurl?UserKeyID=${UserKeyID}&OrganisationKeyID=${OrganisationKeyID}&ModuleName=${ModuleName}&ModuleKeyID=${ModuleKeyID}`,
    );
  return res;
};
export const GetAcceptedQuotationServiceDetails = async (params) => {
  let url = `/AcceptDeclineProposal`;
  const res = await postApiWithAuthenticated(
    ProposalBaseUrlQuote + url,
    params,
  );
  return res;
};

export const GetQuoteLookupList = async (organisationKeyId) => {
  const res = await getListWithAuthenticated(
    ProposalBaseUrlQuote +
      `/GetQuoteLookupList?OrganisationKeyID=${organisationKeyId}`,
  );
  return res;
};

//Get Template Model Data Services Callback function
export const GetProposalModelList = async (id) => {
  const res = await getListWithAuthenticated(
    // `${TemplateBaseUrl}/GetMasterTemplateDetailsWithVariableValues?TemplateKeyID=${params.TemplateKeyID}&ClientKeyID=${params.clientID}`
    `${ProposalBaseUrlQuote}/GetQuoteDetailsModel?QuoteKeyID=${id}`,
  );
  return res;
};

export const GenerateContractFromProposal = async (params) => {
  let url = "/GenerateContractFromProposal";
  const res = await postApi(`${ProposalBaseUrlQuote}${url}`, params);
  return res;
};

// Web Proposal final-step actions (Amend / Save / Accept). Runs outside the
// authenticated app, so no token (mirrors GetProposalModelWithoutToken).
// Endpoints are placeholders until the real ones are ready.
export const AmendWebProposal = async (params) => {
  const res = await postApi(`${ProposalBaseUrlQuote}/AmendWebProposal`, params);
  return res;
};

export const SaveWebProposalInputFields = async (params) => {
  const res = await postApi(
    `${ProposalBaseUrlQuote}/SaveWebProposalInputFields`,
    params,
  );
  return res;
};

// AddUpdateQuote as used from the web-based-proposal flow (client-facing,
// no auth token) — same endpoint AddUpdateProposal.jsx calls via the
// authenticated AddUpdateQuote above, mirrors AmendWebProposal's pattern.
export const AddUpdateQuoteWebProposal = async (params) => {
  const res = await postApi(`${ProposalBaseUrlQuote}/AddUpdateQuote`, params);
  return res;
};

export const AcceptWebProposal = async (params) => {
  const res = await postApi(
    `${ProposalBaseUrlQuote}/AcceptWebProposal`,
    params,
  );
  return res;
};

export const GetContractDetailsForSignEasyList = async (GetContractKeyID) => {
  const res = await getList(
    // `${TemplateBaseUrl}/GetMasterTemplateDetailsWithVariableValues?TemplateKeyID=${params.TemplateKeyID}&ClientKeyID=${params.clientID}`
    `${GetContractDetails}/GetContractDetailsForSignEasy?ContractKeyID=${GetContractKeyID}`,
  );
  return res;
};
export const CopyQuotation = async (GetQuoteKeyID, UserKeyID) => {
  const res = await postApiWithAuthenticated(
    // `${TemplateBaseUrl}/GetMasterTemplateDetailsWithVariableValues?TemplateKeyID=${params.TemplateKeyID}&ClientKeyID=${params.clientID}`
    `${ProposalBaseUrlQuote}/CopyQuotation?QuoteKeyID=${GetQuoteKeyID}&UserKeyID=${UserKeyID}`,
  );
  return res;
};

export const ChangeQuoteStatus = async (QuoteKeyID, UserKeyID) => {
  const res = await getListWithAuthenticated(
    `${ProposalBaseUrlQuote}/ChangeQuoteStatus?QuoteKeyID=${QuoteKeyID}&Action=ChangeReminderStatus&UserKeyID=${UserKeyID}`,
  );
  return res;
};

export const ResendProposal = async (QuoteKeyID, UserKeyID) => {
  const res = await getListWithAuthenticated(
    `${ProposalBaseUrlQuote}/ResendQuote?UserKeyID=${UserKeyID}&QuoteKeyID=${QuoteKeyID}`,
  );
  return res;
};

export const DeleteQuotation = async (QuoteKeyID, UserKeyID) => {
  const res = await postApiWithAuthenticated(
    // `${TemplateBaseUrl}/GetMasterTemplateDetailsWithVariableValues?TemplateKeyID=${params.TemplateKeyID}&ClientKeyID=${params.clientID}`
    `${ProposalBaseUrlQuote}/DeleteQuotation?QuoteKeyID=${QuoteKeyID}&UserKeyID=${UserKeyID}`,
  );
  return res;
};
export const DeleteSingleApiQuote = async (params) => {
  const res = await postApiWithAuthenticated(
    // `${TemplateBaseUrl}/GetMasterTemplateDetailsWithVariableValues?TemplateKeyID=${params.TemplateKeyID}&ClientKeyID=${params.clientID}`
    `${ProposalBaseUrlQuote}/DeleteSingleApiQuote`,
    params,
  );
  return res;
};

export const ArchiveQuotation = async (QuoteKeyID, UserKeyID, IsArchived) => {
  const res = await postApiWithAuthenticated(
    `${ProposalBaseUrlQuote}/ArchiveQuotation?QuoteKeyID=${QuoteKeyID}&UserKeyID=${UserKeyID}&IsArchived=${IsArchived}`,
  );
  return res;
};
